import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import styles from './ui.module.css';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required: every icon-only control needs a name for screen readers. */
  label: string;
  icon: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  active?: boolean;
  bordered?: boolean;
  badge?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, icon, size = 'md', active = false, bordered = false, badge = false, className, ...rest },
  ref,
) {
  const button = (
    <button
      ref={ref}
      type={rest.type ?? 'button'}
      className={[
        styles.iconBtn,
        size === 'sm' ? styles.iconBtnSm : '',
        size === 'lg' ? styles.iconBtnLg : '',
        bordered ? styles.iconBtnBordered : '',
        active ? styles.iconBtnActive : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-label={label}
      title={label}
      aria-pressed={rest['aria-pressed']}
      {...rest}
    >
      {icon}
    </button>
  );

  if (!badge) return button;

  return (
    <span className={styles.iconBtnWrap}>
      {button}
      <span className={styles.badge} aria-hidden="true" />
    </span>
  );
});
